// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Oyb","imageContainer":"e_Pyb","image":"e_Qyb","content":"e_Ryb","category":"e_Syb","title":"e_Tyb","author":"e_Uyb","titleContainer":"e_Vyb"};